import { Route, Routes, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import AppsPage from '../pages/app/Apps/index';

/**
 * Apps Routes
 * Handles the /app/apps/* route — the desktop equivalent of the mobile Hub
 * launcher, listing the CCMS mobile constellation apps the user is entitled to.
 *
 * Pages:
 * - /app/apps - Apps launcher (entitlement-filtered catalogue)
 */
export default function AppsRoutes() {
  return (
    <Routes>
      <Route index element={
        <MainLayout>
          <AppsPage />
        </MainLayout>
      } />

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/app/apps" replace />} />
    </Routes>
  );
}
